module.exports = __webpack_public_path__ + "static/media/unb_antiga.a811e31e.jpg";